// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://classic-blog-space-backend.vercel.app";

export default BASE_URL;
